// extracted by mini-css-extract-plugin
module.exports = {"container":"ie","image":"if","title":"ig","date":"ih"};